<template>
  <div class="expected-end-of-month card-box">
    <div class="remaining-variables container-padding">
      <div class="updated-to">מעודכן ל-{{ updateTime }}</div>
      <div class="title">
        <template v-if="isPredictedCashflowPositive">כמה כסף נשאר להוציא על הוצאות משתנות ב{{this.monthName}}?</template>
        <template v-else>{{this.monthName}} צפוי להסתיים בתזרים שלילי של:</template>
      </div>
      <div class="top-of-mind-metric" :class="{ positive: hasRemainingVariables,
        zero: !hasRemainingVariables,
        negative: !isPredictedCashflowPositive }">
        <animated-number v-bind:value="topOfMindNumber"></animated-number> ₪ {{ numberPrefix }}
      </div>
    </div>
    <div v-if="!isPredictedCashflowPositive" class="divider"></div>
    <div v-if="!isPredictedCashflowPositive" class="eom-description container-padding">
      <div class="remaining-vars">נשארו 0 הוצאות משתנות</div>
      <div>להוציא עד סוף {{this.monthName}}</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import AnimatedNumber from '../../../../../../../../base-components/AnimatedNumber.vue';

export default {
  name: 'ExpectedEndOfMonth',
  components: {
    AnimatedNumber,
  },
  computed: {
    ...mapGetters('cashflowView', ['monthName', 'remainingVariables', 'budgetUpdatedAt', 'predictedBalanceAtEndOfMonth', 'isPredictedIncome']),
    updateTime() {
      const updateHour = moment(this.budgetUpdatedAt).format('H:mm');
      const updateDate = moment(this.budgetUpdatedAt).format('D.M.YY');
      return `${updateHour}, ${updateDate}`;
    },
    topOfMindNumber() {
      return this.isPredictedCashflowPositive ? _.max([this.remainingVariables, 0]) : this.predictedBalanceAtEndOfMonth;
    },
    numberPrefix() {
      if (this.isPredictedCashflowPositive) {
        return '';
      }
      return '- ';
    },
    isPredictedCashflowPositive() {
      return this.predictedBalanceAtEndOfMonth > 0;
    },
    hasRemainingVariables() {
      return this.remainingVariables > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  .expected-end-of-month {
    margin-bottom: 16px;

    .container-padding {
      padding: 8px 18px ;
    }

    .remaining-variables {
      padding-top: 18px;
    }

    .updated-to {
      color: $riseup_gray_2;
      font-size: 10px;
    }

    .title {
      font-family: GretaSans;
      font-size: 24px;
      font-weight: bold;
      line-height: 1.00em;
      margin: 4px 0 32px;
    }

    .top-of-mind-metric {
      font-family: SimplerPro;
      font-size: 46px;
      line-height: 32px;
      margin: 0 0 18px;
      font-weight: bold;

      &.positive {
        color: $riseup_green;
      }
      &.zero {
        color: $riseup_black;
      }
      &.negative {
        color: $riseup_red;
      }
    }
    .divider {
      height: 1px;
      width: 100%;
      background-color: $riseup_gray_0;
    }

    .eom-description {
      padding-top: 12px;
      padding-bottom: 14px;
      font-size: 16px;
      .remaining-vars {
        font-weight: bold;
        color: $riseup_red;
        margin-bottom: 2px;
      }
    }
  }
</style>
